import React from 'react';
import { Link } from 'react-router-dom';

function PrivacyPolicy() {
  return (
    <div className="h-screen overflow-y-auto bg-gradient-to-br from-orange-50 via-white to-amber-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-sm border-b border-orange-100 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img src="/eddy_logo.png" alt="Eddy" className="h-8 w-auto" />
            <span className="text-xl font-semibold text-gray-800">Eddy</span>
          </Link>
          <Link 
            to="/" 
            className="text-orange-600 hover:text-orange-700 font-medium transition-colors"
          >
            Zurück zur App
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-lg shadow-orange-100/50 border border-orange-100 p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            Datenschutzhinweise für „Eddy"
          </h1>
          <p className="text-gray-500 mb-8">Stand: 8.12.2025, Vertragssprache: Deutsch</p>

          <div className="prose prose-gray max-w-none space-y-8">
            
            {/* Section 1 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">1. Wer wir sind (Verantwortlicher)</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                PC‑COLLEGE Training GmbH – Institut für IT‑Training, Stresemannstraße 78, 10963 Berlin, Deutschland.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                Vertretungsberechtigt ist Geschäftsführer Alain B. Barthel.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                Sie erreichen uns unter info@pc-college.de oder +49 (0)30 235 50 0.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Und die Educas Weiterbildungs GmbH, Bayerstr. 21, 80335 München als gemeinsam Verantwortliche gemäß Art. 26 DSGVO.
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">2. Datenschutzkontakte</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                Sie können sich bei Fragen zur Verarbeitung Ihrer Daten und Geltendmachung Ihrer Rechte an beide Verantwortliche wenden.
              </p>
              <p className="text-gray-600 leading-relaxed mb-2">
                <span className="underline">PC‑COLLEGE Training GmbH</span>: datenschutz[at]pc-college.de
              </p>
              <p className="text-gray-600 leading-relaxed">
                <span className="underline">Educas Weiterbildungs GmbH</span>: datenschutz[at]educas.de
              </p>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">3. Für wen diese Hinweise gelten</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                Diese Hinweise gelten für Kursteilnehmende, die „Eddy" über unsere Website nutzen.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Wenn Ihr Arbeitgeber den Kurs gebucht hat, gelten diese Hinweise ebenfalls.
              </p>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">4. Welche Daten wir verarbeiten</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Wir verarbeiten diese Datenkategorien:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                <li><strong>Account‑ und Basisdaten:</strong> Name, E‑Mail‑Adresse, Kurszuordnung (z. B. Kurs-ID).</li>
                <li><strong>Nutzungs‑ und Inhaltsdaten:</strong> Ihre Eingaben im Chat („Prompts") und die Antworten („Outputs").</li>
                <li><strong>Freiwillige Angaben:</strong> z. B. Branche, Rolle oder Vorkenntnisse.</li>
                <li><strong>Technische Daten:</strong> IP‑Adresse, Zeitstempel, Sitzungs‑IDs, Protokolle/Logs.</li>
                <li><strong>Cookies:</strong> Wir setzen nur technisch notwendige Cookies ein (z. B. Session‑Cookie, CSRF‑Token).</li>
                <li><strong>Supportdaten:</strong> Inhalte Ihrer Anfragen und technische Metadaten (z. B. Ticketnummer).</li>
              </ul>
              <p className="text-gray-600 leading-relaxed mt-4">
                <strong>Woher kommen die Daten?</strong><br />
                Wir erhalten die Daten durch Ihre Anmeldung.
              </p>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">5. Wofür wir Daten nutzen und auf welcher Rechtsgrundlage</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Wir nutzen Ihre Daten, um „Eddy" bereitzustellen und sicher zu betreiben:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-3 ml-4">
                <li>
                  <strong>Bereitstellung des Dienstes</strong> (Login, Session, Beantwortung kursbezogener Fragen)<br />
                  – <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertrag/Teilnahme am Kurs).
                </li>
                <li>
                  <strong>Betrieb, Sicherheit und Missbrauchsschutz</strong> (Protokolle/Logs, Fehleranalyse, Rate‑Limits)<br />
                  – <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an stabilem, sicherem Betrieb).
                </li>
                <li>
                  <strong>Personalisierung</strong> (nur wenn Sie freiwillige Angaben machen, z. B. Branche/Rolle)<br />
                  – <strong>Rechtsgrundlage:</strong> je nach Ausgestaltung Art. 6 Abs. 1 lit. b DSGVO (funktional erforderlich) oder Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), falls nicht erforderlich.
                </li>
                <li>
                  <strong>Support & Kommunikation</strong><br />
                  – <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b/f DSGVO.
                </li>
                <li>
                  <strong>Gesetzliche Pflichten und Rechtsdurchsetzung</strong><br />
                  – <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. c/f DSGVO.
                </li>
                <li>
                  Wir verwenden Ihre E-Mail-Adresse, um im Rahmen der Qualitätssicherung Feedback zum konkreten Kurs und unseren Nachbetreuungsangeboten einzuholen (§ 7 Abs. 3 UWG / berechtigtes Interesse). Sie können dem jederzeit widersprechen, ohne dass hierfür andere als die Übermittlungskosten nach den Basistarifen entstehen. Dazu können Sie sich per Klick auf den in jedem Mailing enthaltenen Abmeldelink oder per E-Mail an datenschutz[at]pc-college.de abmelden.
                </li>
              </ul>
              <p className="text-gray-600 leading-relaxed mt-4">
                <strong>Keine automatisierten Einzelentscheidungen:</strong><br />
                Wir treffen keine Entscheidungen im Sinne von Art. 22 DSGVO, die rechtliche Wirkung haben oder Sie in ähnlicher Weise erheblich beeinträchtigen.
              </p>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">6. Keine Nutzung Ihrer Inhalte zum Training von KI‑Modellen</h2>
              <p className="text-gray-600 leading-relaxed">
                Wir verwenden Ihre Eingaben und unsere Antworten nicht zur Weiterentwicklung/Training von KI‑Modellen. Für die Messung unserer Qualität und Verbesserung unseres Systems verwenden wir anonymisierte Nutzungsdaten.
              </p>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">7. Personalisierung</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                Sie können Angaben wie Branche, Berufsrolle oder Vorkenntnisse machen.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                So kann Eddy Beispiele und weitere Inhalte liefern, die besser zu Ihnen passen.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Ohne diese Angaben erhalten Sie allgemeine Inhalte.
              </p>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">8. Wie lange wir Daten speichern</h2>
              <p className="text-gray-600 leading-relaxed">
                Wir speichern personenbezogene Daten nur so lange, wie dies für die jeweiligen Zwecke erforderlich ist oder wie wir gesetzlich dazu verpflichtet sind. Nach spätestens 12 Monaten der Inaktivität eines Nutzers werden die Daten gelöscht oder in einer Form weiterverarbeitet, in der eine Identifizierung der betroffenen Personen nicht mehr möglich ist (Anonymisierung). Dazu gehören: Nutzerkonto und Inhalte (Chats/Uploads), Protokolle/logs, Backups und Supportfälle.
              </p>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">9. Wer Ihre Daten erhält (Empfänger)</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Wir geben Daten nur weiter, wenn es nötig ist oder das Gesetz es verlangt:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-3 ml-4">
                <li>
                  <strong>Interne Stellen:</strong> Kursorganisation, IT‑Betrieb/Sicherheit, Rechtsabteilung (nur, wenn erforderlich) sowie unserer Dachgesellschaft Educas (für die Weiterentwicklung von Eddy).
                </li>
                <li>
                  <strong>Auftragsverarbeiter (Art. 28 DSGVO):</strong>
                  <ul className="list-disc list-inside ml-6 mt-2 space-y-2">
                    <li>Microsoft Azure, Region „Germany West Central", für Hosting und Betrieb unserer Systeme. Die Übermittlung erfolgt auf Basis der EU-Standardvertragsklauseln und ergänzender Schutzmaßnahmen.</li>
                    <li>Clerk (Clerk, Inc., USA) als Authentifizierungsdienst für Registrierung und Anmeldung im Login-Bereich; die Übermittlung in die USA erfolgt auf Grundlage geeigneter Garantien (z. B. EU-Standardvertragsklauseln / Data-Privacy-Framework, soweit anwendbar).</li>
                  </ul>
                </li>
                <li>
                  <strong>Behörden/Gerichte:</strong> Nur, wenn wir dazu rechtlich verpflichtet sind (z. B. aufgrund Auskunfts- oder Mitwirkungspflichten).
                </li>
              </ul>
              <p className="text-gray-600 leading-relaxed mt-4">
                Wir verkaufen keine Daten und setzen keine Werbe‑/Tracking‑Dienste von Dritten ein.
              </p>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">10. Cookies und ähnliche Technologien</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                Wir nutzen nur technisch notwendige Cookies. Diese sind erforderlich, damit Sie eingeloggt bleiben und Ihre Sitzung geschützt ist (z. B. Session‑Cookie, CSRF‑Token).
              </p>
              <p className="text-gray-600 leading-relaxed">
                Wir setzen keine Reichweitenmessung und keine Marketing‑Cookies ein.
              </p>
            </section>

            {/* Section 11 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">11. Sicherheit Ihrer Daten</h2>
              <p className="text-gray-600 leading-relaxed">
                PC-COLLEGE und Educas schützen Ihre Daten mit technischen und organisatorischen Maßnahmen. Dazu gehören u. a.: TLS‑Verschlüsselung, Zugriffskontrollen nach Rollen, Systemhärtung, regelmäßige Updates und Backups. Wir arbeiten nach dem Prinzip der Datensparsamkeit. Azure DB verwendet standardmäßig Verschlüsselung im Ruhezustand. Zugriffs- und Systemereignisse (z. B. Fehler, administrative Aktionen) werden protokolliert, um Missbrauch zu erkennen, Probleme zu beheben und die Sicherheit zu verbessern. Es werden keine sensiblen Daten protokolliert.
              </p>
            </section>

            {/* Section 12 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">12. Einsicht in Inhalte durch Mitarbeitende</h2>
              <p className="text-gray-600 leading-relaxed">
                Es gibt keinen Routinezugriff auf Chatverläufe. In Ausnahmen kann ein enger, protokollierter Zugriff nötig sein, z. B. bei Sicherheitsvorfällen, zur Fehleranalyse oder zur Rechtsdurchsetzung. Ein solcher Zugriff erfolgt nur, wenn er rechtlich zulässig und erforderlich ist.
              </p>
            </section>

            {/* Section 13 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">13. Ihre Rechte nach der DSGVO</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Sie haben folgende Rechte:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                <li><strong>Auskunft</strong> über Ihre Daten und eine Kopie davon (Art. 15 DSGVO).</li>
                <li><strong>Berichtigung</strong> unrichtiger Daten (Art. 16 DSGVO).</li>
                <li><strong>Löschung</strong> („Recht auf Vergessenwerden", Art. 17 DSGVO).</li>
                <li><strong>Einschränkung</strong> der Verarbeitung (Art. 18 DSGVO).</li>
                <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO).</li>
                <li className="font-bold">Widerspruch gegen Verarbeitungen auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (Art. 21 DSGVO).</li>
                <li><strong>Widerruf</strong> einer Einwilligung (Art. 7 Abs. 3 DSGVO) mit Wirkung für die Zukunft.</li>
              </ul>
              <p className="text-gray-600 leading-relaxed mt-4">
                <strong className="font-bold">Beschwerderecht:</strong><br />
                Wenn Sie der Ansicht sind, dass eine Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die Bestimmungen der DSGVO verstößt, haben Sie nach Maßgabe des Art. 77 DSGVO das Recht auf Beschwerde bei einer Aufsichtsbehörde.
              </p>
            </section>

            {/* Section 14 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">14. Vereinbarung zur gemeinsamen Verantwortlichkeit, Art. 26 DSGVO</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                PC‑COLLEGE Training GmbH und Educas Weiterbildungs GmbH handeln als gemeinsam Verantwortliche. Hierzu haben Sie eine Vereinbarung gemäß Art. 26 DSGVO vereinbart.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                Die initiale Datenerhebung erfolgt über die PC‑COLLEGE Training GmbH. Bei Nutzung der App werden die für den Account erforderlichen personenbezogenen Daten in einer Datenbank der Educas Weiterbildungs GmbH gespeichert und dort für Bereitstellung der App verwaltet. Beide Parteien haben Zugriff auf diese Informationen.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Die Informationspflichten gemäß Art. 13 DSGVO werden gemeinsam über diese Erklärung erfüllt. Hierbei lässt jede Partei der anderen Partei sämtliche dafür notwendigen Informationen aus ihrem Wirkbereich zukommen. Die Parteien informieren sich unverzüglich gegenseitig über von Betroffenen geltend gemachte Rechtspositionen. Sie stellen einander sämtliche für die Beantwortung von Auskunftsersuchen notwendigen Informationen zur Verfügung. Betroffene erhalten die Auskunft grundsätzlich von der Stelle, bei der Rechte geltend gemacht wurden.
              </p>
            </section>

            {/* Section 15 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4">15. Änderungen dieser Datenschutzhinweise</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                Wir können diese Hinweise anpassen, wenn sich Produkt, Rechtslage oder Verarbeitung ändern.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                Wesentliche Änderungen teilen wir vorab in der Anwendung oder per E‑Mail mit.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Die aktuelle Fassung ist auf unserer Website abrufbar.
              </p>
            </section>

          </div>
        </div>

        {/* Footer Link */}
        <div className="text-center mt-8">
          <Link 
            to="/terms-of-service" 
            className="text-orange-600 hover:text-orange-700 font-medium transition-colors"
          >
            ← Nutzungsbedingungen ansehen
          </Link>
        </div>
      </main>
    </div>
  );
}

export default PrivacyPolicy;
